/**
 * Email Service - Backend API Integration
 * Production email service using backend API with Resend
 */

// Note: Resend API is called from the backend, not directly from the browser
// to avoid CORS issues

// Email storage for development/testing
const sentEmails = []

// Email templates
const emailTemplates = {
  welcome: (user) => ({
    subject: 'Welcome to Mauritian Groceries! 🎉',
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background: linear-gradient(135deg, #f97316, #ea580c); padding: 30px; text-align: center; border-radius: 10px 10px 0 0;">
          <h1 style="color: white; margin: 0; font-size: 28px;">Welcome to Mauritian Groceries!</h1>
          <p style="color: white; margin: 10px 0 0 0; font-size: 16px;">Your authentic Mauritian food journey starts here</p>
        </div>
        
        <div style="background: white; padding: 30px; border: 1px solid #e5e7eb; border-top: none;">
          <h2 style="color: #1f2937; margin-top: 0;">Hello ${user.firstName}!</h2>
          
          <p style="color: #4b5563; line-height: 1.6;">
            Thank you for joining Mauritian Groceries! We're excited to have you as part of our community of authentic Mauritian food lovers.
          </p>
          
          <div style="background: #f3f4f6; padding: 20px; border-radius: 8px; margin: 20px 0;">
            <h3 style="color: #1f2937; margin-top: 0;">What's next?</h3>
            <ul style="color: #4b5563; line-height: 1.8;">
              <li>Browse our authentic Mauritian products</li>
              <li>Discover traditional spices and ingredients</li>
                  <li>Enjoy free delivery on orders over €50</li>
              <li>Get exclusive deals and new product updates</li>
            </ul>
          </div>
          
          <div style="text-align: center; margin: 30px 0;">
            <a href="${window.location.origin}/products" 
               style="background: #f97316; color: white; padding: 12px 30px; text-decoration: none; border-radius: 6px; font-weight: bold; display: inline-block;">
              Start Shopping Now
            </a>
          </div>
          
          <p style="color: #6b7280; font-size: 14px; margin-top: 30px;">
            If you have any questions, feel free to reach out to our support team.
          </p>
        </div>
        
        <div style="background: #f9fafb; padding: 20px; text-align: center; border-radius: 0 0 10px 10px; border: 1px solid #e5e7eb; border-top: none;">
          <p style="color: #6b7280; font-size: 12px; margin: 0;">
            © 2024 Mauritian Groceries. All rights reserved.<br>
            This email was sent to ${user.email}
          </p>
        </div>
      </div>
    `
  }),

  verification: (user, verificationLink) => ({
    subject: 'Verify Your Email - Mauritian Groceries',
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background: linear-gradient(135deg, #f97316, #ea580c); padding: 30px; text-align: center; border-radius: 10px 10px 0 0;">
          <h1 style="color: white; margin: 0; font-size: 28px;">Verify Your Email</h1>
          <p style="color: white; margin: 10px 0 0 0; font-size: 16px;">Complete your Mauritian Groceries registration</p>
        </div>
        
        <div style="background: white; padding: 30px; border: 1px solid #e5e7eb; border-top: none;">
          <h2 style="color: #1f2937; margin-top: 0;">Hello ${user.firstName}!</h2>
          
          <p style="color: #4b5563; line-height: 1.6;">
            Thank you for signing up with Mauritian Groceries! To complete your registration and start shopping, please verify your email address.
          </p>
          
          <div style="text-align: center; margin: 30px 0;">
            <a href="${verificationLink}" 
               style="background: #f97316; color: white; padding: 12px 30px; text-decoration: none; border-radius: 6px; font-weight: bold; display: inline-block;">
              Verify Email Address
            </a>
          </div>
          
          <p style="color: #6b7280; font-size: 14px;">
            If the button doesn't work, copy and paste this link into your browser:<br>
            <a href="${verificationLink}" style="color: #f97316;">${verificationLink}</a>
          </p>
          
          <p style="color: #6b7280; font-size: 14px; margin-top: 30px;">
            This verification link will expire in 24 hours. If you didn't create an account with Mauritian Groceries, please ignore this email.
          </p>
        </div>
        
        <div style="background: #f9fafb; padding: 20px; text-align: center; border-radius: 0 0 10px 10px; border: 1px solid #e5e7eb; border-top: none;">
          <p style="color: #6b7280; font-size: 12px; margin: 0;">
            © 2024 Mauritian Groceries. All rights reserved.
          </p>
        </div>
      </div>
    `
  }),

  passwordReset: (user, resetLink) => ({
    subject: 'Reset Your Password - Mauritian Groceries',
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background: linear-gradient(135deg, #f97316, #ea580c); padding: 30px; text-align: center; border-radius: 10px 10px 0 0;">
          <h1 style="color: white; margin: 0; font-size: 28px;">Password Reset</h1>
          <p style="color: white; margin: 10px 0 0 0; font-size: 16px;">Secure your Mauritian Groceries account</p>
        </div>
        
        <div style="background: white; padding: 30px; border: 1px solid #e5e7eb; border-top: none;">
          <h2 style="color: #1f2937; margin-top: 0;">Hello ${user.firstName}!</h2>
          
          <p style="color: #4b5563; line-height: 1.6;">
            We received a request to reset your password for your Mauritian Groceries account. If you made this request, click the button below to reset your password.
          </p>
          
          <div style="text-align: center; margin: 30px 0;">
            <a href="${resetLink}" 
               style="background: #f97316; color: white; padding: 12px 30px; text-decoration: none; border-radius: 6px; font-weight: bold; display: inline-block;">
              Reset Password
            </a>
          </div>
          
          <p style="color: #6b7280; font-size: 14px;">
            If the button doesn't work, copy and paste this link into your browser:<br>
            <a href="${resetLink}" style="color: #f97316;">${resetLink}</a>
          </p>
          
          <div style="background: #fef3c7; border: 1px solid #f59e0b; padding: 15px; border-radius: 6px; margin: 20px 0;">
            <p style="color: #92400e; margin: 0; font-size: 14px;">
              <strong>Security Notice:</strong> This link will expire in 1 hour for your security. If you didn't request a password reset, please ignore this email and your password will remain unchanged.
            </p>
          </div>
        </div>
        
        <div style="background: #f9fafb; padding: 20px; text-align: center; border-radius: 0 0 10px 10px; border: 1px solid #e5e7eb; border-top: none;">
          <p style="color: #6b7280; font-size: 12px; margin: 0;">
            © 2024 Mauritian Groceries. All rights reserved.
          </p>
        </div>
      </div>
    `
  }),

  passwordResetSuccess: (user) => ({
    subject: 'Password Reset Successful - Mauritian Groceries',
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background: linear-gradient(135deg, #10b981, #059669); padding: 30px; text-align: center; border-radius: 10px 10px 0 0;">
          <h1 style="color: white; margin: 0; font-size: 28px;">Password Reset Successful</h1>
          <p style="color: white; margin: 10px 0 0 0; font-size: 16px;">Your account is secure</p>
        </div>
        
        <div style="background: white; padding: 30px; border: 1px solid #e5e7eb; border-top: none;">
          <h2 style="color: #1f2937; margin-top: 0;">Hello ${user.firstName}!</h2>
          
          <p style="color: #4b5563; line-height: 1.6;">
            Your password has been successfully reset. Your Mauritian Groceries account is now secure with your new password.
          </p>
          
          <div style="background: #f0fdf4; border: 1px solid #10b981; padding: 15px; border-radius: 6px; margin: 20px 0;">
            <p style="color: #065f46; margin: 0; font-size: 14px;">
              <strong>Security Tip:</strong> If you didn't make this change, please contact our support team immediately.
            </p>
          </div>
          
          <div style="text-align: center; margin: 30px 0;">
            <a href="${window.location.origin}/login" 
               style="background: #10b981; color: white; padding: 12px 30px; text-decoration: none; border-radius: 6px; font-weight: bold; display: inline-block;">
              Sign In to Your Account
            </a>
          </div>
        </div>
        
        <div style="background: #f9fafb; padding: 20px; text-align: center; border-radius: 0 0 10px 10px; border: 1px solid #e5e7eb; border-top: none;">
          <p style="color: #6b7280; font-size: 12px; margin: 0;">
            © 2024 Mauritian Groceries. All rights reserved.
          </p>
        </div>
      </div>
    `
  }),

  orderConfirmation: (order, customer) => ({
    subject: `Order Confirmation #${order.id} - Mauritian Groceries`,
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background: linear-gradient(135deg, #f97316, #ea580c); padding: 30px; text-align: center; border-radius: 10px 10px 0 0;">
          <h1 style="color: white; margin: 0; font-size: 28px;">Order Confirmed! 🎉</h1>
          <p style="color: white; margin: 10px 0 0 0; font-size: 16px;">Thank you for your order</p>
        </div>
        
        <div style="background: white; padding: 30px; border: 1px solid #e5e7eb; border-top: none;">
          <h2 style="color: #1f2937; margin-top: 0;">Hello ${customer.firstName}!</h2>
          
          <p style="color: #4b5563; line-height: 1.6;">
            We've received your order and are preparing it for shipment. Here are your order details:
          </p>
          
          <div style="background: #f3f4f6; padding: 20px; border-radius: 8px; margin: 20px 0;">
            <h3 style="color: #1f2937; margin-top: 0;">Order Information</h3>
            <p style="color: #4b5563; margin: 5px 0;"><strong>Order Number:</strong> ${order.id}</p>
            <p style="color: #4b5563; margin: 5px 0;"><strong>Order Date:</strong> ${new Date(order.orderDate).toLocaleDateString('en-GB')}</p>
            <p style="color: #4b5563; margin: 5px 0;"><strong>Status:</strong> <span style="color: #059669; font-weight: bold;">${order.status}</span></p>
            <p style="color: #4b5563; margin: 5px 0;"><strong>Total Amount:</strong> €${order.total.toFixed(2)}</p>
          </div>
          
          <div style="background: #f3f4f6; padding: 20px; border-radius: 8px; margin: 20px 0;">
            <h3 style="color: #1f2937; margin-top: 0;">Delivery Address</h3>
            <p style="color: #4b5563; margin: 5px 0;">${order.deliveryAddress.name}</p>
            <p style="color: #4b5563; margin: 5px 0;">${order.deliveryAddress.street}</p>
            <p style="color: #4b5563; margin: 5px 0;">${order.deliveryAddress.city} ${order.deliveryAddress.postcode}</p>
            <p style="color: #4b5563; margin: 5px 0;">${order.deliveryAddress.county}, ${order.deliveryAddress.country}</p>
          </div>
          
          <div style="background: #f3f4f6; padding: 20px; border-radius: 8px; margin: 20px 0;">
            <h3 style="color: #1f2937; margin-top: 0;">Order Items</h3>
            ${order.items.map(item => `
              <div style="display: flex; justify-content: space-between; align-items: center; padding: 10px 0; border-bottom: 1px solid #e5e7eb;">
                <div>
                  <p style="color: #1f2937; margin: 0; font-weight: bold;">${item.name}</p>
                  <p style="color: #6b7280; margin: 0; font-size: 14px;">Quantity: ${item.quantity}</p>
                </div>
                <p style="color: #1f2937; margin: 0; font-weight: bold;">€${(item.price * item.quantity).toFixed(2)}</p>
              </div>
            `).join('')}
            <div style="display: flex; justify-content: space-between; align-items: center; padding: 15px 0 0 0; border-top: 2px solid #e5e7eb; margin-top: 10px;">
              <p style="color: #1f2937; margin: 0; font-weight: bold; font-size: 18px;">Total: €${order.total.toFixed(2)}</p>
            </div>
          </div>
          
          <div style="text-align: center; margin: 30px 0;">
            <a href="${window.location.origin}/orders/${order.id}" 
               style="background: #f97316; color: white; padding: 12px 30px; text-decoration: none; border-radius: 6px; font-weight: bold; display: inline-block;">
              Track Your Order
            </a>
          </div>
          
          <p style="color: #6b7280; font-size: 14px;">
            We'll send you another email when your order ships. If you have any questions, please contact our support team.
          </p>
        </div>
        
        <div style="background: #f9fafb; padding: 20px; text-align: center; border-radius: 0 0 10px 10px; border: 1px solid #e5e7eb; border-top: none;">
          <p style="color: #6b7280; font-size: 12px; margin: 0;">
            © 2024 Mauritian Groceries. All rights reserved.<br>
            This email was sent to ${customer.email}
          </p>
        </div>
      </div>
    `
  }),

  orderShipped: (order, customer, trackingNumber) => ({
    subject: `Your Order #${order.id} Has Shipped! 🚚`,
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background: linear-gradient(135deg, #059669, #047857); padding: 30px; text-align: center; border-radius: 10px 10px 0 0;">
          <h1 style="color: white; margin: 0; font-size: 28px;">Your Order Has Shipped! 🚚</h1>
          <p style="color: white; margin: 10px 0 0 0; font-size: 16px;">On its way to you</p>
        </div>
        
        <div style="background: white; padding: 30px; border: 1px solid #e5e7eb; border-top: none;">
          <h2 style="color: #1f2937; margin-top: 0;">Hello ${customer.firstName}!</h2>
          
          <p style="color: #4b5563; line-height: 1.6;">
            Great news! Your order has been shipped and is on its way to you. You can track your package using the tracking number below.
          </p>
          
          <div style="background: #f0fdf4; padding: 20px; border-radius: 8px; margin: 20px 0; border: 1px solid #bbf7d0;">
            <h3 style="color: #1f2937; margin-top: 0;">Delivery Information</h3>
            <p style="color: #4b5563; margin: 5px 0;"><strong>Order Number:</strong> ${order.id}</p>
            <p style="color: #4b5563; margin: 5px 0;"><strong>Tracking Number:</strong> <span style="font-family: monospace; background: #f3f4f6; padding: 2px 6px; border-radius: 4px;">${trackingNumber}</span></p>
            <p style="color: #4b5563; margin: 5px 0;"><strong>Estimated Delivery:</strong> 3-5 business days</p>
          </div>
          
          <div style="text-align: center; margin: 30px 0;">
            <a href="https://www.royalmail.com/track-your-item#/tracking-results/${trackingNumber}" 
               style="background: #059669; color: white; padding: 12px 30px; text-decoration: none; border-radius: 6px; font-weight: bold; display: inline-block;">
              Track Your Package
            </a>
          </div>
          
          <p style="color: #6b7280; font-size: 14px;">
            We'll send you another email when your order is delivered. Thank you for choosing Mauritian Groceries!
          </p>
        </div>
        
        <div style="background: #f9fafb; padding: 20px; text-align: center; border-radius: 0 0 10px 10px; border: 1px solid #e5e7eb; border-top: none;">
          <p style="color: #6b7280; font-size: 12px; margin: 0;">
            © 2024 Mauritian Groceries. All rights reserved.<br>
            This email was sent to ${customer.email}
          </p>
        </div>
      </div>
    `
  }),

  orderDelivered: (order, customer) => ({
    subject: `Your Order #${order.id} Has Been Delivered! 📦`,
    html: `
      <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
        <div style="background: linear-gradient(135deg, #7c3aed, #5b21b6); padding: 30px; text-align: center; border-radius: 10px 10px 0 0;">
          <h1 style="color: white; margin: 0; font-size: 28px;">Order Delivered! 📦</h1>
          <p style="color: white; margin: 10px 0 0 0; font-size: 16px;">Enjoy your authentic Mauritian flavors</p>
        </div>
        
        <div style="background: white; padding: 30px; border: 1px solid #e5e7eb; border-top: none;">
          <h2 style="color: #1f2937; margin-top: 0;">Hello ${customer.firstName}!</h2>
          
          <p style="color: #4b5563; line-height: 1.6;">
            Your order has been successfully delivered! We hope you enjoy your authentic Mauritian products.
          </p>
          
          <div style="background: #faf5ff; padding: 20px; border-radius: 8px; margin: 20px 0; border: 1px solid #e9d5ff;">
            <h3 style="color: #1f2937; margin-top: 0;">Delivery Confirmation</h3>
            <p style="color: #4b5563; margin: 5px 0;"><strong>Order Number:</strong> ${order.id}</p>
            <p style="color: #4b5563; margin: 5px 0;"><strong>Delivered On:</strong> ${new Date().toLocaleDateString('en-GB')}</p>
            <p style="color: #4b5563; margin: 5px 0;"><strong>Delivery Address:</strong> ${order.deliveryAddress.street}, ${order.deliveryAddress.city}</p>
          </div>
          
          <div style="text-align: center; margin: 30px 0;">
            <a href="${window.location.origin}/products" 
               style="background: #7c3aed; color: white; padding: 12px 30px; text-decoration: none; border-radius: 6px; font-weight: bold; display: inline-block;">
              Shop Again
            </a>
          </div>
          
          <p style="color: #6b7280; font-size: 14px;">
            Thank you for choosing Mauritian Groceries! We'd love to hear about your experience. Leave us a review or contact us if you need anything.
          </p>
        </div>
        
        <div style="background: #f9fafb; padding: 20px; text-align: center; border-radius: 0 0 10px 10px; border: 1px solid #e5e7eb; border-top: none;">
          <p style="color: #6b7280; font-size: 12px; margin: 0;">
            © 2024 Mauritian Groceries. All rights reserved.<br>
            This email was sent to ${customer.email}
          </p>
        </div>
      </div>
    `
  })
}

// Generate verification/reset tokens
const generateToken = () => {
  return Math.random().toString(36).substring(2) + Date.now().toString(36)
}

    // Send email using backend API (since Resend can't be called directly from browser)
const sendEmail = async (to, template, data) => {
      try {
        const emailTemplate = template(data)
        
        console.log('📧 Attempting to send email via backend API:', {
          to,
          subject: emailTemplate.subject
        })
        
        // Try to send via our backend API first
        try {
          const response = await fetch('https://maurifood-api.hansye11.workers.dev/api/emails/send', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              to,
              subject: emailTemplate.subject,
              html: emailTemplate.html,
              from: 'Mauritian Groceries <onboarding@resend.dev>'
            })
          })
          
          if (response.ok) {
            const result = await response.json()
            console.log('📧 Backend API Response:', result)
            
      const email = {
              id: result.id || Date.now(),
        to,
              ...emailTemplate,
        sentAt: new Date().toISOString(),
              status: 'sent',
              backendId: result.id
      }
      
      sentEmails.push(email)
      
            console.log('✅ Email sent successfully via backend:', {
        to: email.to,
        subject: email.subject,
              sentAt: email.sentAt,
              backendId: result.id
            })
            
            return email
          } else {
            throw new Error(`Backend API failed: ${response.status}`)
          }
        } catch (backendError) {
          console.warn('⚠️ Backend API not available, using fallback:', backendError.message)
          throw backendError
        }
        
      } catch (error) {
        console.error('❌ Email sending failed, using fallback method:', {
          error: error.message,
          to,
          subject: template(data).subject
        })
        
        // Fallback: Simulate email sending and store for manual sending
        const emailTemplate = template(data)
        
        // Create a detailed email record for manual sending
        const email = {
          id: Date.now(),
          to,
          ...emailTemplate,
          sentAt: new Date().toISOString(),
          status: 'pending_manual_send',
          error: error.message,
          backendId: null
        }
        
        sentEmails.push(email)
        
        // Log the email content for manual sending
        console.log('📧 EMAIL CONTENT FOR MANUAL SENDING:')
        console.log('=====================================')
        console.log('To:', to)
        console.log('Subject:', emailTemplate.subject)
        console.log('HTML Content:', emailTemplate.html)
        console.log('=====================================')
        
        // Show user-friendly message
        console.log('📧 Email queued for manual sending. Check console for email content.')
        
        return email
      }
}

// Email service functions
export const emailService = {
  // Send welcome email after successful registration
  sendWelcomeEmail: async (user) => {
    const template = emailTemplates.welcome(user)
    return await sendEmail(user.email, () => template, user)
  },

  // Send email verification
  sendVerificationEmail: async (user) => {
    const token = generateToken()
    const verificationLink = `${window.location.origin}/verify-email?token=${token}`
    const template = emailTemplates.verification(user, verificationLink)
    
    // Store token for verification (in production, this would be in a database)
    localStorage.setItem(`verification_token_${user.email}`, token)
    
    return await sendEmail(user.email, () => template, user)
  },

  // Send password reset email
  sendPasswordResetEmail: async (user) => {
    const token = generateToken()
    const resetLink = `${window.location.origin}/reset-password?token=${token}`
    const template = emailTemplates.passwordReset(user, resetLink)
    
    // Store token for password reset (in production, this would be in a database)
    localStorage.setItem(`reset_token_${user.email}`, token)
    
    return await sendEmail(user.email, () => template, user)
  },

  // Send password reset success email
  sendPasswordResetSuccessEmail: async (user) => {
    const template = emailTemplates.passwordResetSuccess(user)
    return await sendEmail(user.email, () => template, user)
  },

  // Verify email token
  verifyEmailToken: (email, token) => {
    const storedToken = localStorage.getItem(`verification_token_${email}`)
    return storedToken === token
  },

  // Verify password reset token
  verifyResetToken: (email, token) => {
    const storedToken = localStorage.getItem(`reset_token_${email}`)
    return storedToken === token
  },

  // Clear verification token
  clearVerificationToken: (email) => {
    localStorage.removeItem(`verification_token_${email}`)
  },

  // Clear reset token
  clearResetToken: (email) => {
    localStorage.removeItem(`reset_token_${email}`)
  },

  // Send order confirmation email
  sendOrderConfirmationEmail: async (order, customer) => {
    const template = emailTemplates.orderConfirmation(order, customer)
    return await sendEmail(customer.email, () => template, { order, customer })
  },

  // Send order shipped email
  sendOrderShippedEmail: async (order, customer, trackingNumber) => {
    const template = emailTemplates.orderShipped(order, customer, trackingNumber)
    return await sendEmail(customer.email, () => template, { order, customer, trackingNumber })
  },

  // Send order delivered email
  sendOrderDeliveredEmail: async (order, customer) => {
    const template = emailTemplates.orderDelivered(order, customer)
    return await sendEmail(customer.email, () => template, { order, customer })
  },

  // Get sent emails (for development/testing)
  getSentEmails: () => sentEmails,

  // Get pending emails that need manual sending
  getPendingEmails: () => sentEmails.filter(email => email.status === 'pending_manual_send'),

  // Clear sent emails (for development/testing)
  clearSentEmails: () => {
    sentEmails.length = 0
  },

  // Test email function
  sendTestEmail: async (to) => {
    const testTemplate = {
      subject: 'Test Email from Mauritian Groceries',
      html: `
        <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
          <h1 style="color: #f97316;">Test Email from Mauritian Groceries</h1>
          <p>This is a test email to verify email functionality.</p>
          <p>If you receive this, the email service is working correctly!</p>
        </div>
      `
    }
    
    return await sendEmail(to, () => testTemplate, {})
  }
}

export default emailService
